import { useMemo } from "react"

import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"
import {
  ProductGroupObj,
  ProductGroupObjClass
} from "scrivito/Objs/ProductGroup/ProductGroupObjClass"
import { ensureString } from "shared/lib/ensureString"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"
import { SelectOption } from "shared/types/Select"

interface UseProductGroupOptionsArgs {
  productCategoryObj: ProductCategoryObj | undefined
}

function getProductGroups(
  productCategoryObj?: ProductCategoryObj
): ProductGroupObj[] | undefined {
  if (!productCategoryObj) {
    return ProductGroupObjClass.onSite(getCurrentSiteID()).all().toArray()
  }
  return productCategoryObj.orderedChildren() as ProductGroupObj[] | undefined
}

export function useProductGroupOptions({
  productCategoryObj
}: UseProductGroupOptionsArgs) {
  const productGroups = getProductGroups(productCategoryObj)

  return useMemo<SelectOption<string>[] | undefined>(() => {
    return productGroups?.map(productGroup => ({
      label: ensureString(productGroup.get("title")),
      value: productGroup.contentId()
    }))
  }, [productGroups])
}
